import { render, staticRenderFns } from "./changeSite.vue?vue&type=template&id=420656cd&scoped=true"
import script from "./changeSite.vue?vue&type=script&lang=js"
export * from "./changeSite.vue?vue&type=script&lang=js"
import style0 from "./changeSite.vue?vue&type=style&index=0&id=420656cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420656cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420656cd')) {
      api.createRecord('420656cd', component.options)
    } else {
      api.reload('420656cd', component.options)
    }
    module.hot.accept("./changeSite.vue?vue&type=template&id=420656cd&scoped=true", function () {
      api.rerender('420656cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/LMLiabilityForLosses/cmp/changeSite.vue"
export default component.exports